export const useMapNotifications = (data,t) => {

  return data?.map((item) => {
    const params = {
      ...item.data,
      firstName: item?.data?.user?.firstName || item?.createdBy?.firstName,
      lastName:  item?.data?.user?.lastName || item?.createdBy?.lastName
    };
    // the backend fills in title and body; translations are only a fallback for older notifications without them
    const title = item.title || t(`notifications::title::${item.type}`, {
      ...params,
      defaultValue: 'New notification recived',
    });
    const body = item.body || t(`notifications::body::${item.type}`, params);
    const createdAt = item.createdAt;
    const data = item.data || item?.data?.data;
    const read = !!item.read;

    return {
      title,
      description: body,
      id: item.id,
      userId: item?.createdBy?.id,
      firstName: item?.createdBy?.firstName,
      lastName: item?.createdBy?.lastName,
      read,
      isRead: read,
      body,
      type: item.type,
      notType: item.type,
      channel: item.channel,
      data,
      createdAt,
      createdBy: item?.createdBy
    };
  });
}
